export enum EventCreationStep {
  SELECT_SLOT = 'select slot',
  SELECT_EVENT_TYPE = 'select event type',
  FILL_FORM = 'fill form',
  SUBMITTING = 'submitting event',
  CREATED = 'event created',
}
